import t from "react";
import { PaymentMethodCtx as e } from "./paymentMethodContext.js";
function m() {
  return t.useContext(e);
}
export {
  m as usePaymentMethod
};
//# sourceMappingURL=usePaymentMethod.js.map
